import React, { useContext, useEffect, useState, useRef } from "react";
import { NameContext } from "../context/NameContext";
import CourseCard from "./CourseCard";
import ICONS from "../config/icon";
import Hero from "./Hero";
import { FaSearch } from "react-icons/fa";
import { createPortal } from "react-dom";
import { PaperBG, PaperDarkBG, UnderlineSketch } from "../kits";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import CustomCourseRequestPr from "./CustomCourseRequestPr";
import ModalWrapper from "./utils/ModalWrapper";
import RoughBorder from "../kits/LayoutKit/RoughBorder";

// --- Zusatz: Kapselung für Card + RoughBorder
const CourseCardWithRoughBorder = (props) => {
  const cardRef = useRef();
  return (
    <div ref={cardRef} className="relative">
      <CourseCard {...props} />
      <RoughBorder
        parentRef={cardRef}
        radius={20}
        padding={2}
       color="#AC8E66" 
        strokeWidth={1.1}
        roughness={2.1}
        bowing={0}
      />
    </div>
  );
};

function PersonalizedMarketing() {
  const {
    name,
    setName,
    isNameEntered,
    setIsNameEntered,
    nameColor,
    showFormDirectly,
    setShowFormDirectly,
  } = useContext(NameContext);

  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const coursesSectionRef = useRef(null);
  const location = useLocation();
  const bypassRoutes = ["/lerneinfach/reset-password", "/lerneinfach/forgot-password", "/lerneinfach/kompass"];
  const isBypass = bypassRoutes.some(path => location.pathname.startsWith(path));
  const searchInputRef = useRef(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isBypass) {
      setIsNameEntered(true);
      setShowFormDirectly(false);
      setTimeout(() => {
        setIsNameEntered(true);
      }, 600);
    }
  }, [isBypass, setIsNameEntered]);

  useEffect(() => {
    if (isSearching && filteredCourses.length === 0) {
      setShowModal(true);
    }
  }, [isSearching, filteredCourses]);


  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/get_courses.php")
      .then((response) => {
        if (!response.ok) throw new Error("Fehler beim Laden der Kursdaten");
        return response.json();
      })
      .then((data) => setCourses(data.data))
      .catch((error) => console.error("Fehler beim Laden der Kurse:", error));
  }, []);

  const performSearch = (query) => {
    const searchPattern = query
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ".*")
      .split(" ")
      .map((word) => `(?=.*${word})`)
      .join("");
  
    const regex = new RegExp(searchPattern, "i");
  
    const results = courses.filter((course) => {
      const descriptionText = Array.isArray(course.description)
        ? course.description.join(" ")
        : course.description || "";
  
      return (
 regex.test((course.title ?? "").toLowerCase()) ||
regex.test(descriptionText.toLowerCase()) ||
regex.test((course.instructor ?? "").toLowerCase()) ||
regex.test((course.descriptionExtension ?? "").toLowerCase()) ||
regex.test((course.category ?? "").toLowerCase())
            );
          });
  
    const uniqueResults = [...new Set(results)];
    setFilteredCourses(uniqueResults);
    setIsSearching(true);


    
  
    // NEU: Nur scrollen, wenn Suche ausreichend lang + Input nicht sichtbar
    if (
      query.length >= 3 &&
      uniqueResults.length > 0 &&
      coursesSectionRef.current &&
      searchInputRef.current
    ) {
      const inputRect = searchInputRef.current.getBoundingClientRect();
      const isInputVisible = inputRect.top >= 0 && inputRect.bottom <= window.innerHeight;
  
      if (!isInputVisible) {
        window.scrollTo({
          top: coursesSectionRef.current.offsetTop - 100,
          behavior: "smooth",
        });
      }
    }
  };


  const handleCloseModal = () => {
  setShowModal(false);
  setSearchQuery("");
  setIsSearching(false);
  setFilteredCourses([]);
};
  

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    if (value.trim() === '') {
      setIsSearching(false);
      setFilteredCourses([]);
    } else {
      setIsSearching(true);
      performSearch(value);
    }
  };

  const handleNewSearch = () => {
    setSearchQuery("");
    setIsSearching(false);
    setFilteredCourses([]);
    if (coursesSectionRef.current) {
      window.scrollTo({
        top: coursesSectionRef.current.offsetTop - 100,
        behavior: "smooth",
      });
    }
  };

  const anchor = document.getElementById("name-invitation-anchor");

  const handleNoThanks = () => {
    setName("Neugierig");
    setIsNameEntered(true);
  };

  const isSubmitDisabled = name.trim() === "";

  if (showFormDirectly) {
    return (
      <div className="min-h-screen  text-gray-800">
        <Hero className="mb-0" />
        <div className="flex items-center justify-center">
          <div className="text-center mx-auto max-w-lg p-6 bg-gray-50 rounded-xl shadow-xl">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Moin, schön, dass du da bist.</h2>
            <p className="text-lg text-gray-600 mb-6">Magst du mir deinen Namen verraten?</p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setIsNameEntered(true);
                setShowFormDirectly(false);
                setTimeout(() => {
                  setIsNameEntered(true);
                },600);
              }}
              className="flex flex-col items-center"
            >
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="mein Name ist..."
                className="text-center border border-pink-500 rounded-lg py-2 px-4 mb-4 w-full text-lg"
              />
              <button
                type="submit"
                disabled={isSubmitDisabled}
                className={`$${
                  isSubmitDisabled
                    ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                    : "bg-pink-500 text-white hover:bg-pink-600"
                } px-6 py-2 rounded-full font-bold transition`}
              >
                Weiter hier
              </button>
            </form>
            <button
              onClick={handleNoThanks}
              className="mt-4 text-gray-500 hover:text-gray-700 text-sm"
            >
              Nein, Danke
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <PaperBG> 
    <div className="min-h-screen  text-black">
      <Hero className="mb-12" />
      {!isNameEntered && anchor && createPortal(
        <div className="text-center mx-auto max-w-lg p-6 bg-gradient-to-br from-gray-100 via-white to-gray-100/50  rounded-xl shadow-xl mt-12">
          <p className="text-xs font-bold text-gray-800 mb-4">Moin, schön, dass du da bist.</p>
          <p className="text-sm text-gray-600 mb-6">Magst du mir deinen Namen verraten?</p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setIsNameEntered(true);
              setTimeout(() => {
                setIsNameEntered(true);
              }
              , 600);
            }}
            className="flex flex-col items-center"
          >
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="mein Name ist..."
              className="text-center border border-gray-300 rounded-lg py-2 px-4 mb-4 w-full text-lg focus:outline-none focus:ring-1 focus:ring-pink-500 focus:border-pink-500"
            />
            <button
              type="submit"
              disabled={isSubmitDisabled}
              className={`$${
                isSubmitDisabled
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-pink-500 text-white hover:bg-pink-600"
              } px-6 py-2 rounded-full font-bold transition`}
            >
              Weiter hier
            </button>
          </form>
          <button
            onClick={handleNoThanks}
            className="mt-4 text-gray-500 hover:text-gray-700 text-sm "
          >
            Nein, Danke
          </button>
        </div>,
        anchor
      )}
      <PaperDarkBG >
      <section className=" py-16 sm:py-12 md:py-16">
        <div className="container mx-auto text-left px-6">
        <h2 className="text-md sm:text-xl font-mono mb-2 text-center">
            Moin, 
           <span className="inline-block relative text-orange-300">
                     {name}
                     <UnderlineSketch className=" absolute -bottom-2 left-0 w-full h-2"
                     color="colorWhite"
                     />
                      
                   </span>?
             
          
          
          </h2>
          <h2 className="text-sm md:text-sm sm:text-sm text-white mb-4 font-mono text-center">
           Bei welchen <span className="text-orange-300 ">Problem</span> brauchst Du {" "}
            <span className="text-orange-300 ">Wissenhilfe?</span>
          </h2>
          <input 
  ref={searchInputRef}
  type="text"
  value={searchQuery}
  onChange={handleSearchInputChange}
  placeholder="React, JavaScript, Webdesign, Flutter ..."
  className="
  w-full px-6 py-4
   text-gray-900 text-xs 
   font-mono text-center 
   rounded-md
   shadow-md focus:outline-none focus:ring-1 focus:ring-orange-300 focus:border-transparent"
/>
        </div>
      </section>
      </PaperDarkBG>

      <section ref={coursesSectionRef} className="py-16 ">
        <div className="container mx-auto px-6">
          {isSearching && filteredCourses.length > 0 ? (
            <>
              <h3 className="text-sm font-mono mb-10 text-center"><span>Moin </span>
  <span className="text-black inline-block relative">{ name },
  <UnderlineSketch
      className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-[100%] h-2"
      color="colorBlack"
    />
    </span>{""}
  {filteredCourses.length === 1
    ? " ein Kurs, der zu dir passt."
    : " ein paar Kurse für dich"}
</h3>

              <div
  className="grid grid-cols-1 md:grid-cols-3 gap-8"
>
                {filteredCourses.map((course) => (
                  <CourseCardWithRoughBorder
                    key={course.id}
                    course={course}
                    icon={ICONS[course.icon] || ICONS.default}
                  />
                ))}
              </div>
            </>
          ) : isSearching && filteredCourses.length === 0 ? (
         <div className="text-center font-mono">
{showModal &&
  createPortal(
    <ModalWrapper onClose={handleCloseModal}>
      <CustomCourseRequestPr onClose={handleCloseModal} />
    </ModalWrapper>,
    document.getElementById("modal-root")
  )
}
              </div>
          ) : null}
        </div>
      </section>
    </div>
    </PaperBG>
  );
}

export default PersonalizedMarketing;
